package org.zest.insan_360_website.model

import kotlinx.serialization.Serializable
import kotlinx.datetime.Instant

@Serializable
enum class TestSubmissionStatus { PENDING, VERIFIED, REJECTED }

@Serializable
data class TestResultData(
    val graphs: Map<GraphType, Map<Attribute, Int>>
)

@Serializable
data class SubmitTestRequest(
    val email: String,
    val results: TestResultData
)

@Serializable
data class TestStatusPayload(
    val status: String,
    val testId: String
)

@Serializable
data class DownloadReportRequest(
    val testId: String,
    val email: String
)

@Serializable
data class GenerateReportRequest(
    val verifierEmail: String,
    val submissionId: String,
    val templateName: String,
    val userName: String,
    val userNric: String,
    val graphImageBase64: String // "base64"
)

@Serializable
data class RejectTestRequest(
    val submissionId: String
)

@Serializable
data class RequestReportRequest(
    val testId: String
)

@Serializable
data class SubmissionHistory(
    val testId: String,
    val creditId: String,
    val orgName: String? = null,
    val status: TestSubmissionStatus,
    val submittedAt: Instant,
    val verifiedByEmail: String?,
    val verifiedByName: String?,
    val reportExpiresAt: Instant? = null,
    val reportRequested: Boolean = false,
)

@Serializable
data class SubmissionsHistoryPayload(
    val submissions: List<SubmissionHistory>
)